import View from "./view.js";
import previewView from "./previewView.js";
import icons from "url:../../img/icons.svg";

class ResultView extends View {
  _parentElement = document.querySelector(".results");
  _errorMessage = `No recipe found for your search query! please try again!
  <br>
  <a
    href="https://forkify-api.herokuapp.com/phrases.html"
    target="_blank"
  >Click here</a> to know about the available recipes 😊
  `;
  _message = "";

  _generateMarkup() {
    // console.log(this._data);
    return this._data
      .map((result) => previewView.render(result, false))
      .join("");
  }
}

export default new ResultView();
